module.exports = __webpack_public_path__ + "static/img/gwent.29a62eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gwent.png
// module id = utox
// module chunks = 0